import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "className", "style", "textAligned"];
import React from 'react';
// TODO: Potentially upstream this into react-icon
export var Bullet = function Bullet(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color,
      className = _ref.className,
      style = _ref.style,
      textAligned = _ref.textAligned,
      props = _objectWithoutProperties(_ref, _excluded);

  var sizeProps = {
    width: '1em',
    height: '1em'
  };
  var textAlignedStyle = {
    position: 'relative',
    top: '0.125em'
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: color,
    focusable: "false",
    className: className,
    style: _objectSpread(_objectSpread({}, textAligned ? textAlignedStyle : {}), style)
  }, sizeProps, props), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "5"
  }));
};
Bullet.displayName = 'Bullet';